<template>
  <generic-modal :title="$t('details')" ref="generic_modal">
    <div class="title is-5" v-if="request.profile">
      {{ $t("profile") }} {{ request.profile.name }}
    </div>
    <div class="subtitle is-6">
      {{ format_date_time(request.create_date) }} -
      {{ translate_status(request.status_code) }}
    </div>
    <div v-if="request && request.settings">
      <div class="title is-5">
        {{ $t("data to search") }}
      </div>
      <div class="subtitle is-6">
        {{ format_date_time(request.request_date) }}
      </div>
      <div class="columns">
        <div class="column">
          <div class="title is-6">{{ $t("dpi") }}</div>
          <div class="subtitle is-6">{{ request.settings.dpi }}</div>
        </div>
        <div class="column">
          <div class="title is-6">{{ $t("first name") }}</div>
          <div class="subtitle is-6">{{ request.settings.first_name }}</div>
        </div>
        <div class="column">
          <div class="title is-6">{{ $t("first surname") }}</div>
          <div class="subtitle is-6">{{ request.settings.first_surname }}</div>
        </div>
      </div>

      <div class="title is-5">{{ $t("result") }}</div>
      <div class="subtitle is-6">
        {{ format_date_time(request.response_date) }}
      </div>
      <div class="container">
        <article
          class="message is-warning"
          v-if="request.response_data.result == false"
        >
          <div class="message-header">
            <p>{{ request.response_data.responseCode }}</p>
          </div>
          <div class="message-body">
            {{ request.response_data.mensaje }}
          </div>
        </article>
        <div v-else>
          <pre>{{ request.response_data.data }}</pre>
        </div>
      </div>
    </div>

    <!-- <pre>{{ request }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  change_active_tab,
  generate_error_message_text,
  get,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "OnfidoRequestDetailModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      request: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    change_active_tab: change_active_tab,
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.$root.loader(true);
      get("/renap/request", { uuid: uuid })
        .then((res) => {
          v.request = res;
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.request = {};
      v.error = "";
    },
    translate_status(status) {
      let v = this;
      switch (status) {
        case "C":
          return v.$t("created");
        case "E":
          return v.$t("errored");
        case "T":
          return v.$t("token retrieved");
        case "D":
          return v.$t("data retrieved");
        default:
          return status;
      }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
